import { useMemo } from 'react';

import { useIsSSR } from '~/src/components/hooks/useIsSSR';

/**
 * Browser Extensions often has permissions to modify DOM.
 * If browser extension modifies DOM before hydration it leads to SSR errors.
 * There is no robust solution to prevent this errors.
 * Notes:
 * - 'suppressHydrationWarning' works only with text and attributes in other cases you'll still gets an error
 * - cleanup DOM before hydration doens't work, because some extensions(for example lastPass) will show errors if you remove their DOM elements before hydration
 *
 * The goal of the hook is to trick the password manager extensions and suppress their logic to hydration.
 * The idea behind it is that Password Managers tries to patch inputs, so we set input type to 'button' during SSR and change the type to real one after hydration.
 * So in this case we assume that password managers recognize inputs only after hydration
 **/
export function useSSRSafeFormInputAttributes(type: string) {
  const isSSR = useIsSSR();
  const attributes = useMemo(
    () => ({
      type: isSSR ? 'button' : type,
    }),
    [isSSR, type],
  );
  return attributes;
}
